export const CARD_IN_LIST_TITLE = 'List: ';
export const LIST_SELECT_PLACEHOLDER = 'Search or select list';
